import {t} from 'i18next';
import {AurDataGridColDef} from '../types/types';
import {getUTCDateTimeForDisplay} from './utils';
import { ONLY_DATE_SHOW_FORMAT } from '../constants/constants';

/*
Column name for client management table
*/

export const getMultiClientColumns = (): AurDataGridColDef[] => [
  {
    field: 'name',
    headerName: t('multiClient.client'),
    cellClassName: 'grid-left-padding padding-grid',
    headerClassName: 'grid-left-padding padding-grid',
    width: 300,
    sortable: true,
  },
  {
    field: 'clientCode',
    headerName: t('multiClient.id'),
    width: 300,
    sortable: false,
  },
  {
    field: 'totalBranches',
    headerName: t('multiClient.branches'),
    minWidth: 100,
    flex: 1,
    sortable: false,
  },
  {
    field: 'totalActiveProjects',
    headerName: t('multiClient.projects'),
    minWidth: 100,
    flex: 1,
    sortable: false,
  },
  {
    field: 'lastProjectCreatedTime',
    headerName: t('multiClient.lastProjectAddedOn'),
    sortable: false,
    minWidth: 360,
    isBorderNotRequired: true,
    isDateColumn: true,
    renderCell: (params) => {
      return (
        <span>{getUTCDateTimeForDisplay(params.value, ONLY_DATE_SHOW_FORMAT)}</span>
      );
    },
  },
];
